<template>
    <q-badge rounded :class="['tk-context-badge', toneClass]" :label="label" />
</template>

<script>
const normalizedValue = (value) => String(value || "").trim().toLocaleLowerCase();

const statusTone = (value) => ({
    waitlist: "tk-context-badge--amber",
    active: "tk-context-badge--green",
    exited: "tk-context-badge--grey",
})[normalizedValue(value)] || "tk-context-badge--grey";

const needsTone = (value) => ({
    "tier 1": "tk-context-badge--green",
    "tier 2": "tk-context-badge--amber",
    "tier 3": "tk-context-badge--rose",
})[normalizedValue(value)] || "tk-context-badge--grey";

const riskTone = (value) => ({
    managed: "tk-context-badge--green",
    unmanaged: "tk-context-badge--amber",
})[normalizedValue(value)] || "tk-context-badge--grey";

const pouTone = (value) => {
    const normalized = normalizedValue(value);
    if (normalized.includes("whānau") || normalized.includes("whanau")) return "tk-context-badge--rose";
    if (normalized.includes("hineng")) return "tk-context-badge--purple";
    if (normalized.includes("tinana")) return "tk-context-badge--green";
    if (normalized.includes("taiao")) return "tk-context-badge--blue";
    if (normalized.includes("wairua")) return "tk-context-badge--orange";
    return "tk-context-badge--gold";
};

const badgeTone = (kind, value) => {
    if (kind === "status") return statusTone(value);
    if (kind === "needs") return needsTone(value);
    if (kind === "risk") return riskTone(value);
    if (kind === "pou") return pouTone(value);
    if (kind === "contact") return "tk-context-badge--sage";
    if (kind === "confidential") return "tk-context-badge--grey";
    return "tk-context-badge--grey";
};

export default {
    name: "TkContextBadge",
    props: {
        kind: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        value: {
            type: [Number, String],
            required: true,
        },
    },
    computed: {
        toneClass() {
            return badgeTone(this.kind, this.value);
        },
    },
};
</script>

<style scoped>
.tk-context-badge {
    padding: 4px 9px;
    font-size: 0.72rem;
    font-weight: 550;
    line-height: 1.15;
}

.tk-context-badge--green { background: #dfece5; color: #285847; }
.tk-context-badge--sage { background: #e4ece7; color: #36584c; }
.tk-context-badge--amber { background: #f5ead2; color: #805b1c; }
.tk-context-badge--rose { background: #f1dfe6; color: #84415a; }
.tk-context-badge--purple { background: #e8e1f1; color: #5f4a82; }
.tk-context-badge--blue { background: #dcebf0; color: #326270; }
.tk-context-badge--orange { background: #f3e5d6; color: #805523; }
.tk-context-badge--gold { background: #eee8ce; color: #70601f; }
.tk-context-badge--grey { background: #e8ebe8; color: #56615c; }
</style>
